// extracted by mini-css-extract-plugin
export var numpadContainer = "_mw-1";
export var phoneButton = "_mw-0";